import React from 'react';
import styled from 'styled-components/macro';
import { SPACINGS, Highlight } from '../../utils';
import { NumberValue, Text } from '../../typography';
import { NUMBER_VALUE_TYPE } from '../../types';
import { IconChevron, IconWrapper } from '../../icons';

const ValueStyled = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: column;
  padding: ${SPACINGS[4]};
  border: 2px solid ${(p) => p.color ?? p.theme.colors.primary};
  border-radius: ${(p) => p.theme.dimensions.borderRadius};
  margin-bottom: ${SPACINGS[2]};

  .main {
    display: flex;
    justify-content: space-between;

    .values {
      display: flex;
      flex-direction: column;
    }
  }

  .secondary {
    margin-top: ${SPACINGS[4]};

    .values {
      display: flex;
      justify-content: space-between;
    }
  }
`;

type AccordionValuesProps = {
  values: {
    label: string;
    value: number | string;
    type?: NUMBER_VALUE_TYPE;
    currency?: string;
    color?: string;
    key?: string;
  }[];
  secondaryValues?: {
    label: string;
    value: number;
    type: NUMBER_VALUE_TYPE;
    currency?: string;
  }[][];
};

function AccordionValues(props: AccordionValuesProps) {
  const { values, secondaryValues } = props;

  const [openedAccordion, setOpenedAccordion] = React.useState<
    number | undefined
  >(undefined);

  return (
    <div>
      {values.map((v, i) => {
        const isOpen = openedAccordion === i;
        const valueSize = openedAccordion != null && !isOpen ? 'base' : 'xxl';
        const hasSecondaryValues = (secondaryValues?.[i]?.length ?? 0) > 0;

        const value =
          typeof v.value === 'string' ? (
            <Text size={valueSize} margin="none">
              {v.value}
            </Text>
          ) : v.type === 'currency' ? (
            <NumberValue
              size={valueSize}
              value={v.value}
              type={v.type}
              currency={v.currency}
            />
          ) : (
            <NumberValue size={valueSize} value={v.value} type={v.type} />
          );

        return (
          <ValueStyled key={v.label} color={v.color}>
            <div className="main">
              <div className="values">
                {isOpen ? <Highlight>{value}</Highlight> : value}
                <Text type="label" margin="none">
                  {v.label}
                </Text>
              </div>
              {hasSecondaryValues && (
                <IconWrapper
                  style={{ cursor: 'pointer' }}
                  onClick={() => setOpenedAccordion(isOpen ? undefined : i)}
                >
                  <IconChevron direction={isOpen ? 'top' : 'bottom'} />
                </IconWrapper>
              )}
            </div>
            {isOpen && hasSecondaryValues && (
              <div className="secondary">
                {secondaryValues?.[i].map((v) => (
                  <div key={v.label} className="values">
                    <Text size="sm" type="label">
                      {v.label}
                    </Text>
                    {v.type === 'currency' ? (
                      <NumberValue
                        size="sm"
                        value={v.value}
                        type={v.type}
                        currency={v.currency}
                      />
                    ) : (
                      <NumberValue size="sm" value={v.value} type={v.type} />
                    )}
                  </div>
                ))}
              </div>
            )}
          </ValueStyled>
        );
      })}
    </div>
  );
}

export default AccordionValues;
